export class Loop {
  private static readonly fixedDelta = 1 / 60;
  private static readonly maxStepsPerFrame = 120;
  private frameId = 0;
  private lastTime = 0;
  private accumulator = 0;
  private running = false;

  constructor(
    private readonly update: (deltaSeconds: number, elapsedSeconds: number) => void,
    private readonly render: (deltaSeconds: number) => void,
  ) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.accumulator = 0;
    this.frameId = requestAnimationFrame(this.tick);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.frameId);
  }

  private readonly tick = (time: number) => {
    if (!this.running) return;
    const delta = Math.max(0, (time - this.lastTime) / 1000);
    this.accumulator = Math.min(2, this.accumulator + delta);
    this.lastTime = time;
    let steps = 0;
    while (this.accumulator >= Loop.fixedDelta && steps < Loop.maxStepsPerFrame) {
      this.update(Loop.fixedDelta, time / 1000);
      this.accumulator -= Loop.fixedDelta;
      steps += 1;
    }
    this.render(delta);
    this.frameId = requestAnimationFrame(this.tick);
  };
}
